import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import classnames from 'classnames';
import { useDisabled, DisabledContext } from '@hh.ru/magritte-common-use-disabled';
import { s as styles } from './checkable-card-DJrOyTI9.js';

const genBorderRadiusClasses = (radiusProps) => Object.entries(radiusProps).reduce((acc, [key, value]) => value !== undefined ? [...acc, styles[`border${key}Radius${value}`]] : acc, []);
const genPaddingProps = (paddingProps) => Object.entries(paddingProps).reduce((acc, [key, value]) => (value !== undefined ? { ...acc, [`padding${key}`]: value } : acc), {});
const CheckableCardElementForwardRefRenderFunc = ({ children, padding, paddingLeft, paddingRight, paddingTop, paddingBottom, borderRadius, borderTopLeftRadius, borderTopRightRadius, borderBottomLeftRadius, borderBottomRightRadius, toneHover, disabled, flexible, Element = 'div', input, contentRef, checked = false, focusVisible = false, ...props }, ref) => {
    const paddingProps = genPaddingProps({
        Left: paddingLeft,
        Right: paddingRight,
        Top: paddingTop,
        Bottom: paddingBottom,
    });
    const forceDisabled = useDisabled();
    return (jsxs(Element, { ...props, className: classnames(styles.card, styles[`borderRadius${borderRadius}`], genBorderRadiusClasses({
            TopLeft: borderTopLeftRadius,
            TopRight: borderTopRightRadius,
            BottomLeft: borderBottomLeftRadius,
            BottomRight: borderBottomRightRadius,
        }), {
            [styles.cardDisabled]: forceDisabled || !!disabled,
            [styles.cardChecked]: checked,
            [styles.cardHugContent]: !flexible,
            [styles.cardToneHover]: toneHover,
            'focus-visible': focusVisible,
        }), "data-interactive": true, ref: ref, tabIndex: input || forceDisabled || !!disabled ? -1 : 0, children: [input, jsx("div", { className: styles.content, ref: contentRef, children: jsx("div", { className: styles.contentBorderContainer, style: { padding, ...paddingProps }, children: jsx("div", { className: styles.contentOpacityContainer, children: jsx(DisabledContext.Provider, { value: forceDisabled || !!disabled, children: children }) }) }) })] }));
};
const CheckableCardElement = forwardRef(CheckableCardElementForwardRefRenderFunc);

export { CheckableCardElement };
//# sourceMappingURL=CheckableCardElement.js.map
